import { DialogService } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { MaterialFactor } from 'models/mooring/MaterialFactor';
import { MaterialFactorService } from 'services/material-factor-service';
import { MaterialFactorsCreateEditDialog } from './material-factors-create-edit-dialog';

@autoinject
export class MaterialFactorsListView {
  protected materialFactors: MaterialFactor[] = [];

  constructor(
    private materialFactorService: MaterialFactorService,
    private dialogSerivce: DialogService
  ) {}

  async attached() {
    await this.getMaterialFactors();
  }

  async getMaterialFactors() {
    const response = await this.materialFactorService.list();
    this.materialFactors = response.data;
  }

  protected editMaterialFactor(id: number) {
    void this.dialogSerivce
      .open({
        viewModel: MaterialFactorsCreateEditDialog,
        model: {
          id: id,
        },
        position: () => {
          return {
            top: 0,
          };
        },
      })
      .whenClosed(async ({ output }) => {
        await this.getMaterialFactors();
      });
  }
}
